import "../styles/booking-register.css";
import React, { useState, useEffect, useRef } from "react";
import BookingController from "../services/booking-controller";
import UserController from "../services/user-controller";
import { PrimeIcons } from "primereact/api";
import { Dialog } from "primereact/dialog";
import "react-multi-date-picker/styles/layouts/mobile.css";
import { getToken } from "../utility";
import { InputText } from "primereact/inputtext";

export default function BookingRegister(props) {
	const bookingController = new BookingController();
	const userController = new UserController();
	const [isLoading, setIsLoading] = useState(true);
	const [info, setInfo] = useState({});
	const [persons, setPersons] = useState([]);
	const [price, setPrice] = useState(0);
	const [finalPrice, setFinalPrice] = useState(0);
	const [isVisibleAggrement, setIsVisibleAggrement] = useState(false);
	const [isAgreement, setIsAgreement] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [isVisiblePriceLaws, setIsVisiblePriceLaws] = useState(false);
	const [couponCode, setCouponCode] = useState("");
	const [coupon, setCoupon] = useState({
		isLoading: false,
		isSuccess: false,
		offPercent: 0,
		message: "",
	});

	//> getData
	const getData = async function () {
		try {
			let jsonData = "{}";
			if (window.location.href.indexOf("?") > 0) {
				let urlParams = new URLSearchParams(window.location.href.split("?")[1]);
				jsonData = atob(urlParams.get("q"));
			}
			let objData = JSON.parse(jsonData);

			// prepareReservation
			const prepareResult = await bookingController.prepareReservation(
				objData.id,
				new Date(objData.date),
				objData.total
			);
			if (prepareResult.isSuccess === false) throw prepareResult.message;
			prepareResult.value.data = {
				startDate: new Date(objData.date).toISOString(),
				duration: objData.total,
				residenceRoomTypeId: objData.id,
			};

			setInfo(prepareResult.value);
			//> for test
			let objPersons = [];
			for (let i = 1; i < prepareResult.value.totalCapacity; i++) {
				objPersons.push({
					relationShip: "",
					fullName: "",
					nationalId: "",
				});
			}
			setPersons(objPersons);
			//<
			applyPrices(prepareResult.value, objPersons);
			setIsLoading(false);
		} catch (error) {
			alert(error.toString());
		}
	};

	//> applyPrices
	const applyPrices = function (objInfo, objPersons) {
		let result = {
			extraPersons: objPersons.length + 1 - objInfo.totalCapacity,
			extraDependentPersons: objPersons.filter(
				(item, index) =>
					item.relationShip !== "همراه" && index + 1 >= objInfo.totalCapacity
			).length,
			extraNonDependentPersons: objPersons.filter(
				(item, index) =>
					item.relationShip === "همراه" && index + 1 >= objInfo.totalCapacity
			).length,
			totalDiscount: 0,
			totalPrice: 0,
			totalFinalPrice: 0,
		};
		if (result.extraPersons < 0) result.extraPersons = 0;
		//

		objInfo.days.map((item) => {
			item.price =
				item.isPeak === true ? objInfo.peakRoomPrice : objInfo.roomPrice;
			item.discount = item.price * objInfo.offPercent * 0.01;
			if (item.isPeak === true) {
				item.price +=
					result.extraDependentPersons * objInfo.peakExtraDependentPersonPrice +
					result.extraNonDependentPersons *
						objInfo.peakExtraNonDependentPersonPrice;
			} else {
				item.price +=
					result.extraDependentPersons * objInfo.extraDependentPersonPrice +
					result.extraNonDependentPersons *
						objInfo.extraNonDependentPersonPrice;
			}
			//
			item.finalPrice = item.price - item.discount;
		});
		//
		objInfo.days.map((item) => {
			result.totalPrice += item.price;
			result.totalDiscount += item.discount;
			result.totalFinalPrice += item.finalPrice;
		});
		//
		setInfo(objInfo);
		setPrice(result.totalPrice);
		setFinalPrice(result.totalFinalPrice);
	};

	//> addNewPerson
	const addNewPerson = function () {
		if (persons.length + 1 >= info.totalCapacity + info.totalExtraCapacity) {
			alert(
				"تعداد اعضا نمیتواند بیشتر از مجموع ظرفیت اتاق و ظرفیت اضافه اتاق باشد"
			);
			return;
		}

		let objPersons = [
			...persons,
			{
				relationShip: "",
				fullName: "",
				nationalId: "",
			},
		];
		setPersons(objPersons);
		applyPrices(info, objPersons);
	};

	//> removePerson
	const removePerson = function (person) {
		let objPersons = persons.filter((item) => item !== person);
		setPersons(objPersons);
		applyPrices(info, objPersons);
	};

	//> updatePersonRelationship
	const updatePersonRelationship = function (currentIndex, newValue) {
		let newPersons = persons.map((item, index) => {
			return index === currentIndex
				? { ...item, relationShip: newValue }
				: item;
		});
		setPersons(newPersons);
		applyPrices(info, newPersons);
	};

	//> updatePersonFullName
	const updatePersonFullName = function (currentIndex, newValue) {
		let newPersons = persons.map((item, index) => {
			return index === currentIndex ? { ...item, fullName: newValue } : item;
		});
		setPersons(newPersons);
	};

	//> updatePersonNationalCode
	const updatePersonNationalCode = function (currentIndex, newValue) {
		let newPersons = persons.map((item, index) => {
			return index === currentIndex ? { ...item, nationalId: newValue } : item;
		});
		setPersons(newPersons);
	};

	//> getCoupon
	const getCoupon = async function () {
		try {
			setCoupon((prev) => ({ ...prev, isLoading: true }));
			const result = await userController.getCoupon(couponCode,"Booking");
			setCoupon((prev) => ({
				...prev,
				isLoading: false,
				isSuccess: result.isSuccess,
				message: result.message,
				offPercent: result.value.offPercent,
			}));
		} catch (error) {
			alert(error.toString());
		} finally {
			setCoupon((prev) => ({ ...prev, isLoading: false }));
		}
	};

	//> createReservation
	const createReservation = async function () {
		setIsSaving(true);
		try {
			let apiResult = await bookingController.createReservation(
				info.data.startDate,
				info.data.duration,
				info.data.residenceRoomTypeId,
				persons,
				coupon.isSuccess === true ? couponCode : ""
			);
			if (apiResult.isSuccess === false) throw apiResult.message;

			window.location = apiResult.value;
		} catch (error) {
			alert(error.toString());
		} finally {
			setIsSaving(false);
		}
	};

	//>
	useEffect(() => {
		getData();
	}, []);

	if (!getToken()) {
		window.location = "/#/login?returnUrl=/booking-home";
		return <></>;
	}
	return isLoading ? (
		<span>Loading</span>
	) : (
		<article className="bkr-register">
			<section>
				<h2>مشخصات سرپرست</h2>
				<div className="bkr-owner">
					<div>
						<label>نام و نام خانوادگی</label>
						<span>{info.owner.fullName}</span>
					</div>
					<div>
						<label>کد ملی</label>
						<span>{info.owner.nationalCode}</span>
					</div>
					<div>
						<label>شماره موبایل</label>
						<span>{info.owner.mobile}</span>
					</div>
					<div>
						<label>ایمیل</label>
						<span>&nbsp;{info.owner.email}</span>
					</div>
				</div>
				<h2>مشخصات همراهان</h2>
				<ul className="bkr-persons">
					{persons.map((item, index) => (
						<li key={index}>
							<div className="bkr-p-h">
								{index + 1 < info.totalCapacity && (
									<span className="bkr-p-main">همراه</span>
								)}
								{index + 1 >= info.totalCapacity &&
									item.relationShip === "همراه" && (
										<span className="bkr-p-extra">نفر اضافه غیر تحت تکفل</span>
									)}
								{index + 1 >= info.totalCapacity &&
									item.relationShip !== "همراه" && (
										<span className="bkr-p-extra">نفر اضافه تحت تکفل</span>
									)}
								<div></div>
								<button className="bkr-btn-select">
									<i className={PrimeIcons.SEARCH_PLUS}></i>
									انتخاب از همراهان سابق
								</button>
								<button
									className="bkr-btn-delete"
									onClick={() => removePerson(item)}
								>
									<i className={PrimeIcons.TRASH}></i>
									حذف
								</button>
							</div>
							<div className="bkr-p-b">
								<div>
									<label>نسبت</label>
									<select
										value={item.relationShip}
										onChange={(e) =>
											updatePersonRelationship(index, e.target.value)
										}
									>
										<option value="همسر">همسر</option>
										<option value="پسر">پسر</option>
										<option value="دختر">دختر</option>
										<option value="پدر">پدر</option>
										<option value="مادر">مادر</option>
										<option value="همراه">همراه</option>
									</select>
								</div>
								<div>
									<label>نام و نام خانوادگی</label>
									<input
										type="text"
										value={item.fullName}
										onChange={(e) =>
											updatePersonFullName(index, e.target.value)
										}
									/>
								</div>
								<div>
									<label>کد ملی</label>
									<input
										type="text"
										name="nationalId"
										value={item.nationalId}
										onChange={(e) =>
											updatePersonNationalCode(index, e.target.value)
										}
									/>
								</div>
							</div>
						</li>
					))}
				</ul>

				<div className="bkr-actions">
					<button onClick={() => addNewPerson()}>
						<i className={PrimeIcons.PLUS}></i>افزودن همراه جدید
					</button>
				</div>

				<div className="bkr-agree">
					<input
						type="checkbox"
						id="frm_chxAgreement"
						checked={isAgreement}
						onClick={() => setIsVisibleAggrement(true)}
					/>
					<label
						for="frm_chxAgreement"
						onClick={() => setIsVisibleAggrement(true)}
					>
						با
						<a> قوانین رزرو و لغو رزرو اینترنتی اقامتگاه </a>
						موافقم
					</label>
				</div>

				<Dialog
					header=""
					className="bkr-laws"
					visible={isVisibleAggrement}
					style={{ width: "90vw" }}
					onHide={() => {
						if (!isVisibleAggrement) return;
						setIsVisibleAggrement(false);
					}}
					footer={
						<div className="bkr-agree-buttons">
							<button
								className="bkr-btn-confirm"
								onClick={() => {
									setIsAgreement(true);
									setIsVisibleAggrement(false);
								}}
							>
								<i className={PrimeIcons.CHECK}></i>
								با قوانین و مقررات موافقم
							</button>
						</div>
					}
				>
					<strong>قوانین تحویل، تخلیه:</strong>
					<ul>
						<li>تحویل اتاق ساعت 14:00 و تخلیه اتاق ساعت 12:00 می باشد.</li>
						<li>
							لطفا از به همراه داشتن هرگونه حیوان خانگی خودداری فرمایید.(درصورت
							مشاهده از ورود حیوان جلوگیری بعمل می آید.)
						</li>
						<li>
							احراز هویت مهمان و شرایط محرمیت، از سوی اقامتگاه و بر اساس ارزش‌ها
							و شئونات اسلامی است؛ اقامتگاه‌ها این اختیار را خواهند داشت در صورت
							عدم احراز شرایط محرمیت، از ورود مسافرین به اقامتگاه جلوگیری کرده و
							مطابق قوانینِ استرداد عمل کنند.
						</li>
						<li>کودکان زیر 3 سال رایگان می باشد.</li>
						<li>
							حضور شخص سرپرست خانواده ویا فرد بیمه شده الزامی می باشد درصورت
							تایید عدم حضور نرخ بصورت آزاد محاسبه میگردد.
						</li>
						<li>
							در صورت که بواسطه اقامت مهمان خسارت به اتاق یا مجموعه وارد گردد
							مهمان موظف است بر اساس نرخ تعیین خسارت از طرف مدیریت مجموعه نسبت
							به پرداخت مبلغ ویا جبران خسارت اقدام نماید.
						</li>
						<li>
							چنان که در مدت زمان اقامت مهمان در یک اقامتگاه، عملی خلاف قوانین
							جمهوری اسلامی ایران انجام شود، مسئولیت آن عمل با شخص مرتکب است
							مجموعه تفریحی هیچگونه مسئولیتی در این خصوص ندارد.
						</li>
					</ul>
					<strong>قوانین کنسلی : </strong>
					<ul>
						<li>
							جا به جایی تاریخ اتاق در صورت موجود بودن تا 10روز قبل از ورود
							مهماندر ایام غیر شلوغ امکان پذیر می باشد ودر ایام شلوغ امکان پذیر
							است.
						</li>
						<li>
							کنسلی تا 72 ساعت قبل از ورود مهمان با کسر 50 درصد هزینه یک شب
							اقامت در مجموعه است.
						</li>
						<li>
							کنسلی تا 48 الی 24 ساعت قبل از ورود مهمان مصادف با کسر 70 درصد
							هزینه یک شب اقامت مهمان در اتاق های درمجموعه ها می باشد.
						</li>
						<li>
							کنسلی کمتر از 24 ساعت قبل از ورود مهمان مصادف با 100 درصد جریمه یک
							شب اقامت مهمان در اتاقهای مجموعه می باشد.
						</li>
					</ul>
				</Dialog>

				<Dialog
					header="تعرفه های اقامتگاه"
					visible={isVisiblePriceLaws}
					style={{ width: "500px" }}
					onHide={() => {
						if (!isVisiblePriceLaws) return;
						setIsVisiblePriceLaws(false);
					}}
				>
					<div className="bkr-price-laws">
						<div>
							<label>هزینه اقامت در روز عادی</label>
							<span>{info.roomPrice.toLocaleString("en-US")} ریال</span>
						</div>
						<div>
							<label>هزینه نفر اضافه تحت تکفل در روز عادی</label>
							<span>
								{info.extraDependentPersonPrice.toLocaleString("en-US")} ریال
							</span>
						</div>
						<div>
							<label>هزینه نفر اضافه غیر تحت تکفل در روز عادی</label>
							<span>
								{info.extraNonDependentPersonPrice.toLocaleString("en-US")} ریال
							</span>
						</div>
						<div>
							<label>هزینه اقامت در روز پیک</label>
							<span>{info.peakRoomPrice.toLocaleString("en-US")} ریال</span>
						</div>
						<div>
							<label>هزینه نفر اضافه تحت تکفل در روز پیک</label>
							<span>
								{info.peakExtraDependentPersonPrice.toLocaleString("en-US")}{" "}
								ریال
							</span>
						</div>
						<div>
							<label>هزینه نفر اضافه غیر تحت تکفل در روز پیک</label>
							<span>
								{info.peakExtraNonDependentPersonPrice.toLocaleString("en-US")}{" "}
								ریال
							</span>
						</div>
					</div>
				</Dialog>

				<div className="bkr-buttons">
					<button
						className="bkr-btn-info"
						onClick={() => setIsVisiblePriceLaws(true)}
					>
						مشاهده تعرفه های اقامتگاه
					</button>
					<button
						className="bkr-btn-register"
						disabled={!isAgreement}
						onClick={() => createReservation()}
					>
						<i className={PrimeIcons.SAVE}></i>
						رزرو اقامتگاه
					</button>
				</div>
			</section>

			<aside>
				<h1>{info.residenceName}</h1>
				<div className="bkr-dates">
					<div>
						<label>تاریخ ورود</label>
						<strong>{info.startDate}</strong>
						<b>ساعت {info.startTime}</b>
					</div>
					<i className={PrimeIcons.ARROW_LEFT}></i>
					<div>
						<label>
							مدت اقامت : <b>{info.duration} شب</b>
						</label>
						<strong>{info.endDate}</strong>
						<b>ساعت {info.endTime}</b>
					</div>
				</div>

				<div className="bkr-prices">
					<div className="bkr-prices-info">
						<label>قیمت برای {info.duration} شب</label>
						{persons.length + 1 > info.totalCapacity && (
							<p className="bkr-w-main">
								با احتساب
								{" " + (persons.length + 1 - info.totalCapacity) + " "}
								نفر اضافه
							</p>
						)}
						{persons.length + 1 <= info.totalCapacity && (
							<p className="bkr-w-extra">بدون نفرات اضافه</p>
						)}
					</div>

					<div className="bkr-prices-data">
						<strong>{finalPrice.toLocaleString("en-US")} ریال</strong>
						<div>
							<span>{price.toLocaleString("en-US")}</span>
							<b>{info.offPercent}%</b>
						</div>
					</div>
				</div>

				<h2 className="bkr-room">{info.name}</h2>

				<div className="bkr-days">
					<ul>
						{info.days.map((item, index) => (
							<li
								key={index}
								className={item.isPeak === true ? "bkr-peak-day" : ""}
							>
								<span>{item.day}</span>
								<div>
									<span>{item.price?.toLocaleString("en-US")}</span>
									<b>{item.offPercent}%</b>
								</div>
								<strong>{item.finalPrice?.toLocaleString("en-US")} ریال</strong>
							</li>
						))}
					</ul>
				</div>

				<div className="bkr-coupon">
					<ul>
						<li>
							<label>کد تخفیف</label>
							<span></span>
							<div className="coupon">
								<InputText
									value={couponCode}
									onChange={(e) => setCouponCode(e.target.value)}
								/>
								<button onClick={() => getCoupon()} disabled={coupon.isLoading}>
									بررسی
								</button>
							</div>
						</li>
						{coupon.isSuccess === true && (
							<>
								<li>
									<label>درصد کوپن تخفیف</label>
									<span></span>
									<strong>{coupon.offPercent} %</strong>
								</li>
								<li>
									<label>مبلغ تخفیف</label>
									<span></span>
									<strong>
										{(coupon.offPercent * finalPrice * 0.01).toLocaleString(
											"fa-IR"
										)}{" "}
										ریال
									</strong>
								</li>
								<li>
									<label>مبلغ نهایی قابل پرداخت</label>
									<span></span>
									<strong>
										{(
											finalPrice -
											coupon.offPercent * finalPrice * 0.01
										).toLocaleString("fa-IR")}{" "}
										ریال
									</strong>
								</li>
							</>
						)}
						{coupon.isSuccess === false && coupon.message && (
							<li>{coupon.message}</li>
						)}
					</ul>
				</div>
			</aside>
		</article>
	);
}
